import {Icon} from 'quickstart/components/content'
import {forwardRef} from 'react'
import * as S from './styles'

export const Tag = forwardRef(
  ({children, onClick = undefined, variant = 'default', ...rest}, ref) => {
    return (
      <S.Tag
        hasAction={!!onClick}
        onClick={onClick}
        ref={ref}
        role="listitem"
        variant={variant}
        {...rest}
      >
        {children}
        {!!onClick && (
          <S.ActionIconWrapper>
            <Icon icon="close" size="100%" title="Remove" />
          </S.ActionIconWrapper>
        )}
      </S.Tag>
    )
  },
)

/*
Tag.propTypes = {
  children: T.node,
  onClick: T.func,
  variant: T.oneOf([
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    'action',
    'blue',
    'dark',
    'default',
    'error',
    'green',
    'info',
    'orange',
    'pink',
    'primary',
    'purple',
    'red',
    'secondary',
    'success',
    'turquoize',
    'warning',
    'yellow',
  ]),
}
*/

// TODO use this in multiple Select
export const StyledTag = S.Tag

Tag.Group = S.TagGroup
